const actions = {
  SET_STATE: 'finalist/SET_STATE',
  REFRESH_ERRORS: 'finalist/REFRESH_ERRORS',
  ALL: 'finalist/ALL',
  FETCH_ALL: 'finalist/FETCH_ALL',
  FETCH_MEMBERS_ALL: 'finalist/FETCH_MEMBERS_ALL',
  FETCH_CONTACTS_ALL: 'finalist/FETCH_CONTACTS_ALL',
  FETCH_PARENTS_ALL: 'finalist/FETCH_PARENTS_ALL',
  EXPORT: 'finalist/EXPORT',
  EXPORT_MEMBERS: 'finalist/EXPORT_MEMBERS',
  EXPORT_CONTACTS: 'finalist/EXPORT_CONTACTS',
  EXPORT_PARENTS: 'finalist/EXPORT_PARENTS',
  PRINT: 'finalist/PRINT',
  REFRESH_PRINT: 'finalist/REFRESH_PRINT',
  PRINT_MEMBERS: 'finalist/PRINT_MEMBERS',
  PRINT_CONTACTS: 'finalist/PRINT_CONTACTS',
  PRINT_PARENTS: 'finalist/PRINT_PARENTS',
  REFRESH_MEMBERS_PRINT: 'finalist/REFRESH_MEMBERS_PRINT',
  REFRESH_CONTACTS_PRINT: 'finalist/REFRESH_CONTACTS_PRINT',
  REFRESH_PARENTS_PRINT: 'finalist/REFRESH_PARENTS_PRINT',
  EMAILS: 'finalist/EMAILS',
  EMAILS_CONFIRMATION: 'finalist/EMAILS_CONFIRMATION',
  REFRESH_EMAILS: 'finalist/REFRESH_EMAILS',
  DETAILS: 'finalist/DETAILS',
  MOVE: 'finalist/MOVE',
  ADD: 'finalist/ADD',
  EDIT: 'finalist/EDIT',
  REMOVE: 'finalist/REMOVE',
  CHANGE_IS_DEACTIVATED: 'finalist/CHANGE_IS_DEACTIVATED'
};

export default actions
